<template>
  <v-dialog
    v-model="show"
    max-width="600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
  >
    <v-card class="pa-5">
      <v-card-title>
        {{ cdTitle }}
      </v-card-title>
      <v-card-text>
        {{ cdText }}
        <v-form
          ref="form"
          v-model="valid"
          @keyup.enter="submitDialogBtn(duplicateTitle, duplicateOptions)"
          @submit.prevent
        >
          <v-text-field
            v-model="duplicateTitle"
            data-testid="dialog-input"
            solo
            elevation="6"
            class="rounded-xxl text-body-2 pt-4"
            :rules="titleRules"
            clearable
          />
          <v-radio-group
            v-model="duplicateOptions"
            class="colored-options"
            data-testid="duplicate-options"
          >
            <v-radio
              key="duplicateAsDraft"
              value="duplicateAsDraft"
              color="accent"
              class="black--text pa-5 option rounded-xxl"
              data-testid="duplicate-option-1"
              active-class="selected"
            >
              <template v-slot:label>
                <div>
                  <span class="text-subtitle-1 font-weight-bold">{{ $t('duplicateActivityOptionAsDraftTitle') }}</span><br> 
                  <span class="text-subtitle-2 grey--text font-weight-regular">{{ $t('duplicateActivityOptionAsDraftText') }}</span> 
                </div>
              </template>
            </v-radio>
            <v-radio
              key="duplicateAsItIs"
              value="duplicateAsItIs"
              color="accent"
              class="black--text pa-5 option rounded-xxl"
              data-testid="duplicate-option-2"
              active-class="selected"
            >
              <template v-slot:label>
                <div>
                  <span class="text-subtitle-1 font-weight-bold">{{ $t('duplicateActivityOptionAsItIsTitle') }}</span><br> 
                  <span class="text-subtitle-2 grey--text font-weight-regular">{{ $t('duplicateActivityOptionAsItIsText') }}</span> 
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          ref="cancel"
          data-testid="cancel-button"
          color="darktext"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 cancel"
          :disabled="loading"
          @click="show=false"
        >
          {{ cdCancelBtn }}
        </v-btn>
        <v-btn
          ref="submit"
          data-testid="submit-button"
          type="submit"
          color="accent"
          min-width="100"
          dark
          elevation="0"
          class="rounded-xxl text-none px-4 submit"
          :loading="loading"
          @click="submitDialogBtn(duplicateTitle, duplicateOptions)"
        >
          {{ cdSubmitBtn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { ruleRequired, ruleValidMin2Max70Characters } from '../rules/formRules.js';
import i18n from '../plugins/i18n';

export default {
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdText: {
      type: String,
      default: ''
    },
    cdSubmitBtn: {
      type: String,
      default: i18n.t('submit')
    },
    cdCancelBtn: {
      type: String,
      default: i18n.t('cancel')
    },
    title: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data(){
      return{
        valid: true,
        titleRules: ruleRequired('labelTitle').concat(ruleValidMin2Max70Characters('labelTitle')),
        alertMsg: '',
        check: false,
        duplicateOptions: "duplicateAsDraft",
        duplicateTitle: ''
      }
    },    
    computed: {
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                    this.$refs.form.reset()
                }
            }
        }
    },
    created() {
        this.duplicateTitle = '(' + i18n.t('copyInTitle')+ ') ' + this.title
        this.$nextTick(() => {
            this.$refs.form.validate()
        })
    },
    methods: {
      submitDialogBtn(title, duplicateOption) {
        this.valid = this.$refs.form.validate()
        if(this.valid){
          this.$emit('proceedSubmit',title, duplicateOption)
          //this.$refs.form.reset()
        }
      },
  },
}
</script>